import { z } from 'zod';

export const benefitCardProviderCategorySchema = z.enum([
  'meal',
  'gift',
  'transport',
  'culture',
  'health',
  'other',
]);
export type BenefitCardProviderCategory = z.infer<typeof benefitCardProviderCategorySchema>;

export const createBenefitCardProviderSchema = z.object({
  name: z.string().min(1).max(100),
  slug: z.string().min(1).max(120).regex(/^[a-z0-9-]+$/, 'Lower-case slug'),
  country: z.string().regex(/^[A-Z]{2}$/, 'ISO 3166-1 alpha-2'),
  category: benefitCardProviderCategorySchema,
  color: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, '#RRGGBB hex')
    .nullable()
    .optional(),
  icon: z.string().max(50).nullable().optional(),
  isActive: z.boolean().default(true),
  vatExempt: z.boolean().default(false),
});
export type CreateBenefitCardProviderInput = z.infer<typeof createBenefitCardProviderSchema>;

export const updateBenefitCardProviderSchema = createBenefitCardProviderSchema.partial();
export type UpdateBenefitCardProviderInput = z.infer<typeof updateBenefitCardProviderSchema>;

export const listBenefitCardProvidersQuerySchema = z.object({
  q: z.string().max(120).optional(),
  country: z.string().regex(/^[A-Z]{2}$/).optional(),
  category: benefitCardProviderCategorySchema.optional(),
  active: z.coerce.boolean().optional(),
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(50),
});
export type ListBenefitCardProvidersQuery = z.infer<typeof listBenefitCardProvidersQuerySchema>;
